import { pageLoadingStatusMixin } from 'relapp-loading';
import ProductsApi from '../services/api/product.js';

export default {
    mixins: [pageLoadingStatusMixin],
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getProducts().then(this.finishLoading);
    },
    methods: {
        /**
         * Get the products.
         *
         * @return {Promise}
         */
        getProducts() {
            return ProductsApi.get();
        }
    }
};
